// Flow section types
export type FlowSectionType = "rating" | "welcome" | "negative-feedback" | "question" | "personal-detail" | "company-detail" | "consent" | "thank-you" | "feedback-thank-you";

export interface FlowSectionField {
	id: string;
	field_key: string;
	field_type: string;
	label: string;
	placeholder: string;
	is_required: boolean;
	is_visible: boolean;
	sort_order: number;
}

export interface FlowSection {
	id: string;
	type: FlowSectionType;
	title: string;
	description?: string;
	image_url?: string | null; // Image URL for the section
	enabled: boolean;
	canToggle: boolean; // Can be enabled/disabled
	canReorder: boolean; // Can be reordered (only questions)
	canDelete: boolean; // Can be deleted (only questions)
	fields?: FlowSectionField[];
}

export interface Question {
	id: string;
	title: string;
	description?: string;
	format: "video" | "text" | "any" | "audio";
	video_option_label?: string;
	video_option_description?: string;
	audio_option_label?: string;
	audio_option_description?: string;
	text_option_label?: string;
	text_option_description?: string;
}

export const DEFAULT_OPTION_VALUES = {
	video_option_label: "Record a video testimonial",
	video_option_description: "Share your story face-to-face. Video testimonials feel more personal and help others connect with your experience.",
	audio_option_label: "Record an audio testimonial",
	audio_option_description: "Prefer voice? Record your thoughts as audio. Quick and easy to share your experience.",
	text_option_label: "Write a text testimonial",
	text_option_description: "Prefer typing? Write out your thoughts at your own pace. You can always edit before submitting.",
} as const;

export interface FormBuilderState {
	// Flow sections
	sections: FlowSection[];
	questions: Question[];

	// Settings
	autoApproveTestimonials: boolean;
	selectedTagIds: string[];
	theme: "light" | "dark" | "system-default";

	// UI state
	selectedSectionId: string | null;
}

export interface OriginalFormState {
	formTitle: string;
	sections: FlowSection[];
	questions: Question[];
	autoApproveTestimonials: boolean;
	selectedTagIds: string[];
	theme: "light" | "dark" | "system-default";
	status: "published" | "unpublished";
}

// Default sections - empty array since data comes from backend
export const DEFAULT_SECTIONS: FlowSection[] = [];

// Default questions - empty array since data comes from backend
export const DEFAULT_QUESTIONS: Question[] = [];

// Theme options
export const THEME_OPTIONS = [
	{ value: "light", label: "Light" },
	{ value: "dark", label: "Dark" },
	{ value: "system-default", label: "System default" },
] as const;

// Format options for questions
export const FORMAT_OPTIONS = [
	{ value: "text", label: "Text" },
	{ value: "video", label: "Video" },
	{ value: "audio", label: "Audio" },
	{ value: "any", label: "Any" },
] as const;
